import './App.css';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";


// import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Home from './component/Home';
import { Featured } from './component/featured/Featured';
import { Featured1 } from './component/featured/Featured1';
import { Featured2 } from './component/featured/Featured2';
import Footerdemo from './component/Footerdemo';
import Navbar from './component/Navbar';
import Hero from './component/Idea';
import { Women1 } from './component/WomenEntrepreneur/Women1';
import { Women2 } from './component/WomenEntrepreneur/Women2';
import { Women3 } from './component/WomenEntrepreneur/Women3';
import { Women4 } from './component/WomenEntrepreneur/Women4';
import HealthCare1 from './component/Healthcare/Helthcare1';
// import HealthCare2 from './component/Healthcare/Helthcare2';
import HealthCare3 from './component/Healthcare/Healthcare3';
import HealthCare4 from './component/Healthcare/Healthcare4';
import HealthCare5 from './component/Healthcare/Healthcare5';
import News1 from './component/NewsMain/News1';
import News2 from './component/NewsMain/News2';
import News3 from './component/NewsMain/News3';
import News4 from './component/NewsMain/News4';
import News5 from './component/NewsMain/News5';
import { Article1 } from './component/articles/Article1';
import { Article2 } from './component/articles/Article2';
import { Article3 } from './component/articles/Article3';
import { Article4 } from './component/articles/Article4';
import { Article5 } from './component/articles/Article5';
import { Article6 } from './component/articles/Article6';
import { Article7 } from './component/articles/Article7';
import { Article8 } from './component/articles/Article8';
import ScrollToTop from './component/ScrollToTop';
import HealthCare2 from './component/Healthcare/Healthcare2';
import { Magazines } from './component/navcontent/Magazines';
// import { LeadersInsights } from './component/navcontent/LeadersInsights';
// import { CoverStory } from './component/navcontent/CoverStory';
import { NewsPage } from './component/navcontent/NewsPage';
import { ArticlePage } from './component/navcontent/ArticlePage';
import { AboutUs } from './component/navcontent/AboutUs';
import CoverStory from './component/navcontent/CoverStory';
import LeadersInsights from './component/navcontent/LeadersInsights';
import { Unitedpassenger } from './component/navcontent/news-brief/Unitedpassenger';
import { Weakeningrupee } from './component/navcontent/news-brief/News1-15-01';
import { Metaindia } from './component/navcontent/news-brief/News2-15-01';
import { Onlyfans } from './component/navcontent/news-brief/News3-15-01';
import { Bitcoin100000 } from './component/navcontent/news-brief/News4-15-01';
import { Applesrecord } from './component/navcontent/news-brief/News5-15-01';
import { Investec } from './component/navcontent/news-brief/News6-15-01';
import { Tiktokban } from './component/navcontent/news-brief/News7-15-01';
import { Toyota } from './component/navcontent/news-brief/News8-15-01';
import { Israilhamas } from './component/navcontent/news-brief/News10-15-01';



function App() {

  const router = createBrowserRouter([
    {
      path: "/",
      element: <><Home /></>
    },
    {
      path: "*",
      element: <><Home/></>
    },
    {
      path: "/magazines",
      element: <><Magazines/><ScrollToTop/></>
    },
    {
      path: "/leaders-insights",
      element: <><LeadersInsights/><ScrollToTop/></>
    },
    {
      path: "/cover-stories",
      element: <><CoverStory/><ScrollToTop/></>
    },
    {
      path: "/latest-news",
      element: <><NewsPage/><ScrollToTop/></>
    },
    {
      path: "/articles",
      element: <><ArticlePage/><ScrollToTop/></>
    },
    {
      path: "/about-us",
      element: <><AboutUs/><ScrollToTop/></>
    },
    {
      path: "/oliver-johnson",
      element: <><Featured/></>
    },
    {
      path: "/fernando-perez",
      element: <><Featured1/></>
    },
    {
      path: "/susan-brown",
      element: <><Featured2/></>
    },
    {
      path: "/women1",
      element: <> <Women1/><ScrollToTop/></>
    },
    {
      path: "/women2",
      element: <> <Women2/><ScrollToTop/></>
    },
    {
      path: "/women3",
      element: <><Women3/><ScrollToTop/></>
    },
    {
      path: "/women4",
      element: <><Women4/><ScrollToTop/></>
    },
    {
      path: "/healthcare1",
      element: <><HealthCare1/></>
    },
    {
      path: "/healthcare2",
      element: <><HealthCare2/><ScrollToTop/></>
    },
    {
      path: "/healthcare3",
      element: <><HealthCare3/><ScrollToTop/></>
    },
    {
      path: "/healthcare4",
      element: <><HealthCare4/><ScrollToTop/></>
    },
    {
      path: "/healthcare5",
      element: <><HealthCare5/><ScrollToTop/></>
    },
    {
      path: "/news1",
      element: <><News1/><ScrollToTop/></>
    },
    {
      path: "/news2",
      element: <><News2/><ScrollToTop/></>
    },
    {
      path: "/news3",
      element: <><News3/><ScrollToTop/></>
    },
    {
      path: "/news4",
      element: <><News4/><ScrollToTop/></>
    },
    {
      path: "/news5",
      element: <><News5/><ScrollToTop/></>
    },
    {
      path: "/article1",
      element: <><Article1/></>
    },
    {
      path: "/article2",
      element: <><Article2/></>
    },
    {
      path: "/article3",
      element: <><Article3/></>
    },
    {
      path: "/article4",
      element: <><Article4/></>
    },
    {
      path: "/article5",
      element: <><Article5/></>
    },
    {
      path: "/article6",
      element: <><Article6/></>
    },
    {
      path: "/article7",
      element: <><Article7/></>
    },
    {
      path: "/article8",
      element: <><Article8/></>
    },
    {
      path: "/weakening-rupee-raises",
      element: <><Weakeningrupee/></>
    },
    {
      path: "/meta-india-apologizes",
      element: <><Metaindia/></>
    },

    {
      path: "/is-onlyfans-now-available-in-china",
      element: <><Onlyfans/></>
    },

    {
      path: "/bitcoin-surpasses-$100000-for-the-first-time",
      element: <><Bitcoin100000/></>
    },
    {
      path: "/apple's-record",
      element: <><Applesrecord/></>
    },
    
    {
      path: "/investec-issues-hold",
      element: <><Investec/></>
    },
    {
      path: "/tik-tok-faces-u.s.ban-by-sunday",
      element: <><Tiktokban/></>
    },
    {
      path: "/toyota-subsidiary-agrees",
      element: <><Toyota/></>
    },
    {
      path: "/key-factors-behind-the-israel-hamas-ceasefire-deal",
      element: <><Israilhamas/></>
    },
  ])
  return (
   <>
 
  
 <RouterProvider router={router} />
 
 <Hero/>
 <Footerdemo/>

   </>
  );
}

export default App;
